import React, { Component } from "react";
import { Form, Row, Col, Button, Alert, Modal } from "react-bootstrap";



import "containers/common/List.css";


import ReactTable from "react-table";
import 'react-table/react-table.css';
import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Select from 'react-select';

export default class NaberList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "nabers",
            dataRecord: "nabers",
            dataSetPrimaryKey: "nabers_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        
        this.setState({ isLoading: false });      
    }


    componentWillUnmount() {
        //this.setState({ nabers: [] });
    }

    


    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }
    

    
    
    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        if (event.detail !== 0) {
            let data = [...this.props.data];
            var r = window.confirm("Are you sure you want to delete this record?");
            if (r === true) {
                console.log(cellInfo);

                data[cellInfo.index].archived_date = new Date();
                await this.handleDataSave(data[cellInfo.index]).then((result) => {
                    data.splice(cellInfo.index, 1);
                    this.props.updateTableState(data, this.state.dataSet);
                }
                )
            };
        }
    };


    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = parseInt(event.target.value.replace(/[^0-9.]/g, ""));
        
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };


    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {        
        let data = [...this.props.data];
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(event);
        data[cellInfo.index][cellInfo.column.id] = dt.toLocaleDateString('en-AU',options);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
        
    }

    handleNabersRatingTypeChange = (cellInfo, event) => {
        let data = [...this.props.data];
        console.log(event);
        if(event){
            data[cellInfo.index][cellInfo.column.id] = event.value;
        }
        else{
            data[cellInfo.index][cellInfo.column.id] = null;
        }
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }
    
    handleNabersRatingValuesChange = (cellInfo, event) => {
        let data = [...this.props.data];
        console.log(event);
        if(event){
        data[cellInfo.index][cellInfo.column.id] = event.value;
        }
        else{
            data[cellInfo.index][cellInfo.column.id] = null;
        }
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        if (data[0].hasOwnProperty("rating_expiry_date")) {
            data.sort(function (a, b) { return b.rating_expiry_date - a.rating_expiry_date });
        }
        if (data[0].hasOwnProperty("building_name")) {
            data.sort(function (a, b) { return b.building_name - a.building_name });
        }
        this.props.updateTableState(data, this.state.dataSet);

    }


    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];
        
        if (cellInfo.column.id == "rating_area") {            
            return (<input
                onChange={this.handleNumberChange.bind(null, cellInfo)}
                onBlur={this.handleSave.bind(null, cellInfo)}
                type="number"
                className="no-border form-control"
                value={cellValue!=null ? cellValue : ""}
                step=".1"
                min="0" 
                pattern="^\d+(?:\.\d{1})?$"
                />
            );
        }

        if (cellInfo.column.id == "rating_type") {
            if (cellValue) {
                return (<div><Select
                    value={{ value: cellValue, label: cellValue }}
                    onChange={this.handleNabersRatingTypeChange.bind(null, cellInfo)}
                    options={this.props.nabersRatingTypeOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                    isClearable
                /></div>
                );
            }
            else {
                return (<div><Select
                    
                    onChange={this.handleNabersRatingTypeChange.bind(null, cellInfo)}
                    options={this.props.nabersRatingTypeOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                    isClearable
                /></div>
                );
            }
        }
        if (["energy_rating", "energy_rating_no_gp", "water_rating", "waste_rating", "indoor_env_rating"].indexOf(cellInfo.column.id) >= 0) {
            if (cellValue || cellValue==0) {
                return (<div><Select
                    value={{ value: cellValue, label: cellValue }}
                    onChange={this.handleNabersRatingValuesChange.bind(null, cellInfo)}
                    options={this.props.nabersRatingValues}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                    isClearable
                /></div>
                );
            }
            else {
                return (<div><Select
                    value={null}
                    onChange={this.handleNabersRatingValuesChange.bind(null, cellInfo)}
                    options={this.props.nabersRatingValues}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                    isClearable
                /></div>
                );

            }
        }

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
                
        }
    }

    
    addRecord = async event => {
        let data = [...this.props.data];
        
        let new_record ;
        if (data.length>0){
            
            new_record = Object.assign({}, data[0]);
            new_record['property_id']= this.props.filter.propertyid;
            new_record['new_record']= true;
            new_record['modified']= true;
            new_record['nabers_id']=null;
            new_record['created_by'] = this.props.user;
            new_record['last_edited_by']= this.props.user;
            new_record['last_edited_by']= this.props.user;
            new_record['rating_expiry_date']= new Date();
            new_record['date_last_checked']= new Date();
        }else{
            new_record= {
                        property_id: this.props.filter.propertyid,
                        created_by: this.props.user,
                        last_edited_by: this.props.user,
                        new_record: true,
                        energy_rating: null,
                        energy_rating_no_gp: null,
                        water_rating: null,
                        waste_rating: null,
                        indoor_env_rating: null,
                        rating_expiry_date: new Date(),
                        date_last_checked: new Date(),
                        modified: true
                    }
        }
        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.unshift(new_record);
        this.props.updateTableState(data, this.state.dataSet);
    }

    renderTable(data) {
        const columns = [

            {
                id: 'nabers_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'nabers_id'

            }, {
                id: 'building_name',
                Header: 'Building',
                accessor: 'building_name',
                Cell: this.renderEditable

            }, {
                id: 'beec_nabers_id',
                Header: 'BEEC Nabers ID',
                maxWidth: 100,
                accessor: 'beec_nabers_id',
                Cell: this.renderEditable

            }, {
                id: 'rating_expiry_date',
                Header: 'Rating Expiry Date',
                maxWidth: 120,
                accessor: d => {
                    if (d.rating_expiry_date) {
                        return Moment(d.rating_expiry_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                Cell: this.renderEditable,
                sortMethod: (a, b) => { return (Moment(a, 'DD-MM-YYYY') - Moment(b, 'DD-MM-YYYY')) },
                style: { textAlign: "center" }

            }, {
                id: 'rating_type',
                Header: 'Rating Type',
                maxWidth: 200,
                accessor: 'rating_type',
                Cell: this.renderEditable

            }, {
                id: 'rating_area',
                Header: 'Rating Area',
                maxWidth: 100,
                accessor: 'rating_area',
                Cell: this.renderEditable,
                style: { textAlign: "right" }

            }, {
                id: 'energy_rating',
                Header: 'Energy Rating',
                maxWidth: 120,
                accessor: 'energy_rating',
                Cell: this.renderEditable

            }, {
                id: 'energy_rating_no_gp',
                Header: 'Energy Rating - No Green Power',
                maxWidth: 120,
                accessor: 'energy_rating_no_gp',
                Cell: this.renderEditable

            }, {
                id: 'water_rating',
                Header: 'Water Rating',
                maxWidth: 120,
                accessor: 'water_rating',
                Cell: this.renderEditable

            }, {
                id: 'waste_rating',
                Header: 'Waste Rating',
                maxWidth: 120,
                accessor: 'waste_rating',
                Cell: this.renderEditable

            }, {
                id: 'indoor_env_rating',
                Header: 'Indoor Env Rating',
                maxWidth: 120,
                accessor: 'indoor_env_rating',
                Cell: this.renderEditable

            }, {
                id: 'date_last_checked',
                Header: 'Date Last Checked',
                maxWidth: 120,
                accessor: d => {
                    if (d.date_last_checked) {
                        return Moment(d.date_last_checked)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                Cell: this.renderEditable,
                style: { textAlign: "center" }

            },
            {
                Header: '',
                accessor: 'nabers_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={true}
                />
            )
        }



    }

    
    renderComponent() {
        return (
            <div className="NabersData">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Row >
                    <Col className="text-right" >
                        
                        {/*   <Button variant="secondary" size="sm" onClick={this.props.refreshDataSet}  >Refresh</Button>  */}
                        <Button variant="secondary" size="sm" onClick={this.addRecord}  >Add</Button>
                            
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.nabersRatingTypeOptions.length > 0 && this.renderTable(this.props.data)}
                        </Col>
                    </Row>
           

            </div>
        );
    }
    render() {
        if (!this.props.data) {
            return null
        }
        else {
            return (

                <div className="NabersSection">
                    {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
                </div>
            );
        }
  }
}
